var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./CompanyPartner.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-34c676b8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CompanyPartner.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyPartner/CompanyPartner.vue
// module id = 597
// module chunks = 0